import React from 'react'

import { NOOP } from 'constants/commonConstans'
import { BrandFormEnum } from 'services/Branding/types'

import SplitterFormFonts from './SplitterFormFont'
import SplitterFormStyle from './SplitterFormStyle'
import type { SplitterFormBrandType, SplitterBrandForms } from './splitterTypes'

const FORM_MAP: SplitterBrandForms = {
  [BrandFormEnum.STYLE]: SplitterFormStyle,
  ...SplitterFormFonts,
}

const SplitterFormBrand: SplitterFormBrandType = (props) => {
  const Form = FORM_MAP[props.form] || NOOP
  return <Form {...props} />
}

export default React.memo(SplitterFormBrand) as typeof SplitterFormBrand
